var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',{staticClass:"pt-0",domProps:{"innerHTML":_vm._s(_vm.$t(_vm.title))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }